import React, { PureComponent } from 'react'

import classNames from 'classnames'

export default class TextArea extends PureComponent {
  static defaultProps = {
    placeholder: '',
    name: 'note',
    maxLength: 2000,
    isControlled: false,
    value: ''
  }

  render() {
    const {
      name,
      placeholder,
      onChange,
      className,
      maxLength,
      value,
      isControlled,
      input,
      meta,
      ...rest
    } = this.props
    const settings = {
      maxLength,
      className: classNames([
        'textarea',
        className,
        {
          'textarea--invalid':
            meta && (meta.visited || meta.touched || meta.submitFailed) && meta.invalid
        }
      ]),
      name: (input && input.name) || name,
      placeholder,
      value: (input && input.value) || value,
      onChange: (input && input.onChange) || ((e) => onChange(e.target.value)),
      onBlur: input && input.onBlur,
      onFocus: input && input.onFocus
    }

    if (isControlled) settings.value = value
    return <textarea {...settings} {...rest} style={{ fontSize: '16px' }} />
  }
}
